import React, { useState } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import emailjs from 'emailjs-com';

const SubscribeForm = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    chatId: '',
    months: 1,
  });

  const getAmount = (months) => 30 + (months - 1) * 20;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setForm({ ...form, phone: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const currentYear = new Date().getFullYear(); // ✅ Get current year
  
    const templateParams = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      months: form.months,
      chatId: form.chatId,
      year: currentYear, // ✅ Add year here
    };
  
    try {
      await emailjs.send(
        'your_service_id',
        'your_template_id',
        templateParams,
        'your_public_key'
      );
      alert('Email sent! Check your inbox for the channel link.');
    } catch (error) {
      console.error('Email sending failed:', error);
      alert('Something went wrong while sending the email.');
    }
  };
  

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: 500,
        mx: 'auto',
        mt: 4,
        mb: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 3,
        border: '1px solid #ccc',
        borderRadius: 2,
        
      }}
    >
      <Typography variant="h5" fontWeight="bold" textAlign="center">
        Subscribe to Premium Channel
      </Typography>

      <TextField
        label="Name"
        name="name"
        value={form.name}
        onChange={handleChange}
        required
        fullWidth
      />

      <TextField
        label="Email"
        name="email"
        type="email"
        value={form.email}
        onChange={handleChange}
        required
        fullWidth
      />

      <PhoneInput
        country={'us'}
        value={form.phone}
        onChange={handlePhoneChange}
        inputStyle={{ width: '100%' }}
        inputProps={{
          name: 'phone',
          required: true,
        }}
      />

      <TextField
        label="Telegram Chat ID"
        name="chatId"
        value={form.chatId}
        onChange={handleChange}
        required
        fullWidth
      />

      <FormControl fullWidth required>
        <InputLabel>Subscription Length (months)</InputLabel>
        <Select
          name="months"
          value={form.months}
          label="Subscription Length (months)"
          onChange={handleChange}
        >
          {[...Array(12)].map((_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1} Month(s) — ${getAmount(i + 1)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography textAlign="center" fontWeight="bold">
        Total: ${getAmount(Number(form.months))}
      </Typography>

      <Button style={{backgroundColor: '#000000'}} type="submit" variant="contained" size="large">
        Pay & Receive Link
      </Button>
    </Box>
  );
};

export default SubscribeForm;
